import React, { FC } from "react";
import { faMinus } from "@fortawesome/pro-regular-svg-icons/faMinus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Minus: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faMinus} {...props} />
);
